import { useCallback, useState } from "react"
import { useHttp } from '../providers/http'

const useShops = () => {
    const http = useHttp()
    const [isLoading, setIsLoading] = useState(true);
    const [shops, setShops] = useState([]);

    const setLoading = () => {
        setIsLoading(true);
        return () => setIsLoading(false);
    }

    const getShopsByBrand = useCallback((brand) => {
        const unload = setLoading();
        http.get("/shops")
            .then(({ data }) => {
                const ordered =
                    data.sort((a, b) => {
                        if (a[brand] && b[brand]) {
                            return a[brand] - b[brand]
                        }

                        if (a[brand]) {
                            return -1
                        }

                        if (b[brand]) {
                            return 1
                        }

                        return 0
                    })
                setShops(ordered)
            })
            .finally(unload)
    }, [http])

    const getShopsWithGeo = useCallback(geoObj => {
        const unload = setLoading();
        http.get(`/shops/geolocation/${geoObj.lat}/${geoObj.lng}`)
            .then(({ data }) => {
                setShops(data)
            })
            .finally(unload)
    }, [http])

    const getShops = useCallback(() => {
        const unload = setLoading();
        http.get("/shops")
            .then(({ data }) => {
                setShops(data)
            })
            .finally(unload)
    }, [http])

    const getShopsWithZip = useCallback(zip => {
        const unload = setLoading();
        http.get(`/shops/distance/${zip}`)
            .then(({ data }) => {
                setShops(data)
            })
            .finally(unload)
    }, [http])

    return {
        getShopsWithGeo,
        getShops,
        getShopsWithZip,
        getShopsByBrand,
        shops,
        isLoading,
    }
}

export default useShops;